import React, { useState, useEffect, useContext, useRef } from 'react'
import axios from 'axios'
import { Table, Input, Space, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons';
import EditUserButton from './editUserButton';
import DeleteUserButton from './deleteUserButton';
import { AppContext } from '../App';
import { configConsumerProps } from 'antd/es/config-provider';
import moment from 'moment-timezone';


const FetchCustomer = () => {
  const { user } = useContext(AppContext);

  const API_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('Authentication');

  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: Math.floor(window.screen.height/100),
  });


  const [hasData, setHasData] = useState(false)
  const [totalCustomer, setTotalCustomer] = useState(0)
  const [totalBronze, setTotalBronze] = useState(0)
  const [totalSilver, setTotalSilver] = useState(0)
  const [totalGold, setTotalGold] = useState(0)

  const [allData, setAllData] = useState([])
  const [bronzeData, setBronzrData] = useState([])
  const [silverData, setSilverData] = useState([])
  const [goldData, setGoldData] = useState([])

  const [typeAll, setTypeAll] = useState('primary')
  const [typeBronze, setTypeBronze] = useState('')
  const [typeSilver, setTypeSilver] = useState('')
  const [typeGold, setTypeGold] = useState('')

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
      clearFilters();
      setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({

      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
          style={{
          padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
      >
          <Input
          ref={searchInput}
          placeholder={`Search User`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
              marginBottom: 8,
              display: 'block',
          }}
          />
          <Space>
          <Button
              type="primary"
              icon={<SearchOutlined />}
              size="small"
              style={{
              width: 120,
              }}
              onClick={() => {
                  confirm({
                      closeDropdown: false,
                  });
                  setSearchText(selectedKeys[0]);
                  setSearchedColumn(dataIndex);
              }}
          >
              Search
          </Button>
          <Button
              onClick={() => {
                  clearFilters
                  handleReset(clearFilters)
                  confirm({
                      closeDropdown: false,
                  });
                  setSearchText(selectedKeys[0]);
                  setSearchedColumn(dataIndex);
              }}
              size="small"
              style={{
              width: 50,
              }}
          >
              Reset
          </Button>
          </Space>
      </div>
      ),
      filterIcon: (filtered) => (
      <SearchOutlined
          style={{
          color: filtered ? '#000000' : undefined,
          }}
      />
      ),
      onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownOpenChange: (visible) => {
      if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
      }
      },
  });
  
  const columns = [
    {
      title: 'เบอร์โทร',
      width: 100,
      dataIndex: 'phone',
      key: 'phone',
      // fixed: 'left',
      ...getColumnSearchProps('phone'),
      render: (text, record) => (
        <div style={{ fontWeight: 600, color: "#3a9bdc" }}>
          {text}
        </div>
      )    
    },
    {
        title: 'ยอดสะสม (บาท)',
        width: 120,
        dataIndex: 'totalUse',
        key: 'totalUse',
        // fixed: 'left',
        render: (text, record) => (
          <div>
            {text}
          </div>
        ),
    },
    {
        title: 'ระดับสมาชิก',
        width: 90,
        dataIndex: 'customerTier',
        key: 'customerTier',
        // fixed: 'left',
        render: (text, record) => (
          <div>
            {text}
          </div>
        ),
    },
    {
      title: 'สถานะ',
      width: 90,
      dataIndex: 'status',
      key: 'status',
      // fixed: 'left',
      render: (text, record) => (
        <div>
          {text === "created" ? <b style={{color:'green'}}>เปิดใช้งาน</b> : "ลบบัญชี"}
        </div>
      ),
    },{
      title: 'เริ่มเป็นสมาชิก',
      width: 120,
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text, record) => (
        <div>
          {moment.tz(moment(text), 'Asia/Bangkok').format('DD/MM/YYYY H:mm')}
        </div>
      ),
    },{
      title: 'ชื่อ - นามสกุล',
      width: 120,
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <div>
          { record.name}
        </div>
      ),
  },{
        title: 'วันเกิด',
        width: 50,
        dataIndex: 'birthDate',
        key: 'birthDate',
        render: (text, record) => (
          <div>
            { text ? moment.tz(moment(text), 'Asia/Bangkok').format('DD/MM/YYYY H:mm') : ""}
          </div>
        ),
    },{
        title: 'อีเมล',
        width: 50,
        dataIndex: 'email',
        key: 'email',
        render: (text, record) => (
          <div>
            { text ? text : ""}
          </div>
        ),
      }
  ]

  const fetchData = async () => {
    try {
      const response = await axios.get(`${API_URL}getListCustomer`, {
        headers: {
          'Authorization': `bearer ${token}`,
          'Content-Type': 'application/json'
        },
        params: {
          page: pagination.current,
          pageSize: pagination.pageSize,
        },
      })

      const adjustedData = await response.data.map((customer) => ({
        ...customer,
        key: customer.id,
      }));

      setData(adjustedData)
      console.log(adjustedData)

      if(adjustedData.length !== 0){
        setHasData(true)
      }
      
      const bronzeData = adjustedData.filter((item) => item.customerTier === 'Bronze')
      const silverData = adjustedData.filter((item) => item.customerTier === 'Silver')
      const goldData = adjustedData.filter((item) => item.customerTier === 'Gold')
      
      setAllData(adjustedData)
      setBronzrData(bronzeData)
      setSilverData(silverData)
      setGoldData(goldData)
      
      setTotalCustomer(adjustedData.length)
      setTotalBronze(bronzeData.length)
      setTotalSilver(silverData.length)
      setTotalGold(goldData.length)

      setPagination((prevPagination) => {
        return {
          ...prevPagination,
          total: response.total,
          pageSize: Math.floor(window.screen.height / 100),
        };
      });
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
        fetchData()
  },[])

  const setDisplayData = function (tiername){
    if(tiername === 'all'){
      setData(allData)
      setTypeAll('primary')
      setTypeBronze('')
      setTypeSilver('')
      setTypeGold('')
    }else if(tiername === 'bronze'){
      setData(bronzeData)
      setTypeAll('')
      setTypeBronze('primary')
      setTypeSilver('')
      setTypeGold('')
    }else if(tiername === 'silver'){
      setData(silverData)
      setTypeAll('')
      setTypeBronze('')
      setTypeSilver('primary')
      setTypeGold('')
    }else if(tiername === 'gold'){
      setData(goldData)
      setTypeAll('')
      setTypeBronze('')
      setTypeSilver('')
      setTypeGold('primary')
    }
  }

  return (
    <div className="fetch-event-table">
      ระดับสมาชิก : <Button type={typeAll} onClick={()=> setDisplayData('all')}>ทั้งหมด ({totalCustomer})</Button>  &nbsp;
      <Button type={typeBronze} onClick={()=> setDisplayData('bronze')}>Bronze ({totalBronze})</Button> &nbsp;
      <Button type={typeSilver} onClick={()=> setDisplayData('silver')}>Silver ({totalSilver})</Button> &nbsp;
      <Button type={typeGold} onClick={()=> setDisplayData('gold')}>Gold ({totalGold})</Button>  
      <br/><br/>
      {data && hasData ? (
        <Table
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={(newPagination) => setPagination(newPagination)}
          scroll={{
            x: 400,
          }}
          rowKey="id"
        />
      ) : (
        <p>Loading</p>
      )}
    </div>
  )
}

export default FetchCustomer